import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../common/Sidebar"; // Ensure Sidebar component is imported
import "../../styles/AdminDashboardStyles.css";

function AdminDashboard() {
  const navigate = useNavigate();

  const goToProjects = () => navigate("/admin/projects");
  const goToProperties = () => navigate("/admin/properties");

  return (
    <div
      className="dashboard-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/adminImages/dashboard.jpg)`,
      }}
    >
      {/* Sidebar */}
      <div className="dashboard-sidebar">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="dashboard-content">
        {/* Header */}
        <header className="dashboard-header">
          <h1>Panel Administrativo</h1>
          <p>
            Bienvenido al panel administrativo. Aquí puedes gestionar proyectos y propiedades.
          </p>
        </header>

        {/* Main Section */}
        <main className="dashboard-main">
          <div className="buttons-container">
            <button className="btn" onClick={goToProjects}>
              Proyectos
            </button>
            <button className="btn" onClick={goToProperties}>
              Propiedades
            </button>
          </div>
        </main>

        {/* Footer */}
        <footer className="dashboard-footer">
          Panel de administración | Constructora Cantabria © 2024
        </footer>
      </div>
    </div>
  );
}

export default AdminDashboard;
